<template>
<div id="CreditNoteView">
    <div :class="`loader${loaderClass}`" v-show="loading"></div>

    <div class="web-right-sidebar"> <!--right sidebar-->
        <div class="right-asset-tab-list purchase-order-right-tab">
            <div id="tabs" class="containerTab" v-if="cantAccessPage === true">
                <div class="tabs">
                    <a v-on:click="activetab=1" v-bind:class="[ activetab === 1 ? 'active w-100' : '' ]">Credit/Debit Note Details</a>
                </div>
                <div class="content">
                    <div v-if="activetab === 1" class="tabcontent list-view">
                            <div class="row form-group border-bottom pb-2 pt-3 pl-3 pr-3">
                                <!-- <span class="work-order-icon"> <i class="hi-icon icon-flbill"></i> </span> -->
                                <label class="col">Note Number #:</label>
                                <span class="col">{{note_number}}</span>
                            </div>
                            <div class="row form-group border-bottom pb-2 pl-3 pr-3">
                                <!-- <span class="work-order-icon"> <i class="hi-icon icon-flbill"></i> </span> -->
                                <label class="col">Type:</label>
                                <span class="col">{{note_type}}</span>
                            </div>
                            <div class="row form-group border-bottom pb-2 pl-3 pr-3">
                                <!-- <span class="work-order-icon"> <i class="hi-icon icon-flbill"></i> </span> -->
                                <label class="col">Reference:</label>
                                <span class="col">{{reference}}</span>
                            </div>
                            <template v-if="showCreditNoteFields">
                                <div class="row form-group border-bottom pb-2 pl-3 pr-3">
                                    <!-- <span class="work-order-icon"> <i class="hi-icon icon-flman-user"></i> </span> -->
                                    <label class="col">Customer :</label>
                                    <span class="col">{{customer}}</span>
                                </div>
                                <div class="row form-group border-bottom pb-2 pl-3 pr-3">
                                    <!-- <span class="work-order-icon"> <i class="hi-icon icon-flbill"></i> </span> -->
                                    <label class="col">Invoice # :</label>
                                    <span class="col">{{invoice}}</span>
                                </div>
                            </template>
                            <template v-else>
                                <div class="row form-group border-bottom pb-2 pl-3 pr-3">
                                    <!-- <span class="work-order-icon"> <i class="hi-icon icon-flman-user"></i> </span> -->
                                    <label class="col">Vendor :</label>
                                    <span class="col">{{vendor}}</span>
                                </div>
                                <div class="row form-group border-bottom pb-2 pl-3 pr-3">
                                    <!-- <span class="work-order-icon"> <i class="hi-icon icon-flbill"></i> </span> -->
                                    <label class="col">Vendor Invoice # :</label>
                                    <span class="col">{{bill}}</span>
                                </div>
                            </template>
                            <div class="row form-group border-bottom pb-2 pl-3 pr-3">
                                <!-- <span class="work-order-icon"> <i class="hi-icon icon-flcalendar2"></i> </span> -->
                                <label class="col">Date of Issue:</label>
                                <span class="col">{{date_of_issue}}</span>
                            </div>
                            <div class="row form-group border-bottom pb-2 pl-3 pr-3">
                                <!-- <span class="work-order-icon"> <i class="hi-icon icon-flcalendar2"></i> </span> -->
                                <label class="col">Expiry Date:</label>
                                <span class="col">{{expiry_date}}</span>
                            </div>
                            <div class="row form-group border-bottom pb-2 pl-3 pr-3">
                                <!-- <span class="work-order-icon"> <i class="hi-icon icon-flbill"></i> </span> -->
                                <label class="col">Reason:</label>
                                <span class="col">{{reason}}</span>
                            </div>
                            <div class="row form-group border-bottom pb-2 pl-3 pr-3">
                                <!-- <span class="work-order-icon"> <i class="hi-icon icon-flman-user"></i> </span> -->
                                <label class="col">Sales User:</label>
                                <span class="col">{{user}}</span>
                            </div>
                            <div class="row form-group border-bottom pb-2 pl-3 pr-3">
                                <!-- <span class="work-order-icon"> <i class="hi-icon icon-flplaceholder-filled-point"></i> </span> -->
                                <label class="col">Location :</label>
                                <span class="col">{{location}}</span>
                            </div>
                            <div class="row form-group border-bottom pb-2 pl-3 pr-3">
                                <!-- <span class="work-order-icon"> <i class="hi-icon icon-flbill"></i> </span> -->
                                <label class="col">Notes:</label>
                                <span class="col">{{notes}}</span>
                            </div>
                            <div class="row form-group border-bottom pb-2 pl-3 pr-3">
                                <!-- <span class="work-order-icon"> <i class="hi-icon icon-flbill"></i> </span> -->
                                <label class="col">Terms &amp; Conditions:</label>
                                <span class="col">{{terms_conditions}}</span>
                            </div>
                    </div>
                </div>
            </div>
        </div>
    </div> <!--right sidebar-->
    <div id="page-content-wrapper" class="admin-content-area purchase-order-left-section">
        <template v-if="cantAccessPage === true">
            <div class="page-name asset-view-page-name purchase-order-title">
                <div class="page-title"> # {{note_number}}</div>
                    <clear-cache-data :pageKey="[pageKey]" ></clear-cache-data>
                <div class="btn-groups text-right">
                    <button type="submit" id="editCreditNoteBtn" v-on:click="editCreditNote()" class="btn btn-primary"><i class="fp-edit-icon"></i> Edit
                    </button>
                    <button type="submit" class="btn btn-secondary" v-on:click.prevent="goPreviousPath" >
                        <i class="fp-back"> </i>    Back
                    </button>

                </div>
            </div>
            <div class="container-fluid">
                <div id="workorder-detail work-order-view-top" class="admin-page-content credit-note-view">
                  <section class="internal-container">
                   <div id="tabs" class="containerTab mt-1">
                    <div class="tabs">
                      <a v-on:click="active=1" v-bind:class="[ active === 1 ? 'active' : '' ]">Credit Note Details</a>
                      <a v-on:click="activityLogs()" v-bind:class="[ active === 2 ? 'active' : '' ]">Activity Log</a>
                    </div>
                    <div class="content">
                      <div v-show="active === 1" class="tabcontent">
                    <section class="internal-container" >
                        <template v-if="itemsArr.length == 0 || itemsArr == undefined">
                            <div class="lineitem-main-section">
                            <h5>No Line Item Added</h5>
                            </div>
                        </template>
                        <template v-else>
                            <div class="table-responsive-sm">
                                <table aria-describedby="table" id="contact_table" class="table table-sm table-bordered font-1" v-if="itemsArr != undefined && itemsArr.length > 0">
                                    <thead>
                                        <tr class="table-primary">
                                            <th>Part</th>
                                            <th>Description</th>
                                            <th>Quantity</th>
                                            <th class="text-right">Unit Price</th>
                                            <th class="text-right">Amount</th>
                                            <th>Tax </th>
                                            <th class="text-right">Total</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item, index) in itemsArr" v-bind:key="index">
                                            <td v-if="item.item_code != null"> {{ item.item_code}} | {{ item.item_name }} </td>
                                            <td v-else> - </td>
                                            <td v-if="item.description != null && item.description != ''"> {{ item.description}} </td>
                                            <td v-else> - </td>
                                            <td> {{ amountFormatNumber(item.item_qty)}} </td>
                                            <td class="text-right"> {{ amountFormat(item.item_price)}} </td>
                                            <td class="text-right"> {{ amountFormat(item.amount)}} </td>
                                            <td v-if="item.tax_name != null"> {{ item.tax_name}} </td>
                                            <td v-else> - </td>
                                            <td class="text-right"> {{ amountFormat(item.item_total)}} </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </template>
                    </section>
                    <div class="order-summary mt-4" v-show="active === 1"> <!--Description section-->
                        <div class="row">
                            <div class="col-md-6 offset-md-6">
                                <div class="bg-white radius-5 p-3">
                                    <label class="font-bold"> SUMMARY </label>
                                    <table aria-describedby="table" class="table table-sm table-bordered">
                                        <tr class="table-secondary">
                                            <td> Subtotal: </td>
                                            <td class="text-right"> {{amountFormat(sub_total)}} </td>
                                        </tr>
                                        <tr>
                                            <td> Tax Amount: </td>
                                            <td class="text-right discount-order-box">
                                            {{amountFormat(tax_amount)}}</td>
                                        </tr>
                                        <tr class="table-secondary">
                                            <td> Total: </td>
                                            <td class="order-total text-right"> {{amountFormat(total)}} </td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div> <!--Description section-->
                    </div>
                      <div v-show="active === 2" class="tabcontent" id="customer-activity-logs" >
                          <credit-note-activity-log-list :activityLogVal="activityLogsTabValue"></credit-note-activity-log-list>
                      </div>
                    </div>
                   </div>
                  </section>
                </div>
            </div>
        </template>
        <template v-else-if="cantAccessPage === false">
            <div class="container-fluid">
                <div class="bg-white text-center">
                    <h1>
                        Oops!</h1>
                    <h2>
                        403 </h2>
                    <div class="error-details">
                        Sorry!, You don't have permission to access this page.
                    </div>
                </div>
            </div>
        </template>
        <template v-else>
            <loading-content></loading-content>
        </template>
        <app-footer></app-footer>
    </div>
</div>
</template>
<script>
import Vue from 'vue';


import {commonMixins} from '../../mixins/commonMixins';
import ActivityLogListView from '@/components/ActivityLogList.vue';

Vue.component("credit-note-activity-log-list", ActivityLogListView);

export default {
    name: "CreditNoteView",
    // metaInfo: {
    //   // title will be injected into parent titleTemplate
    //   title: "Credit-Debit Note View | " +process.env.COPYRIGHT_NAME
    // },
    mixins:[commonMixins],
    data: () => ({
        itemsArr:[],
        loading:false,
        permissions:[],
        cantAccessPage:"",
        canListCreditNote:false,
        creditNoteId : 0,
        activetab: 1,
        note_number:'',
        date_of_issue:'',
        expiry_date:'',
        customer:'',
        invoice:'',
        vendor:'',
        bill:'',
        location:'',
        user:'',
        reference:'',
        reason:'',
        notes:'',
        terms_conditions:'',
        note_type:'',
        status:'',
        sub_total:'',
        tax_amount:'',
        total:'',
        showCreditNoteFields:true,
        // activityLogsTabValue: "creditNoteList",
        pageKey:"",
        active: 1,
        activityLogsTabValue: "dontLoadList",
        activityLoaded:false,
    }),
    watch:{
        permissions: function(permission){
            var self = this;
            permission.forEach(function (permissions) {
                if(permissions.name == 'view_credit_note') {
                    self.cantAccessPage = true;
                }
                if(permissions.name == 'list_credit_note') {
                    self.canListCreditNote = true;
                }
            });
            if(self.cantAccessPage == ''){
                self.cantAccessPage = false;
            }
        }
    },
    mounted: function() {
        var self = this;
        self.creditNoteId = this.$route.params.id;
        self.getPermissions();
        self.loadCreditNoteData();
        var pathUrl = window.location.pathname;
        var segments = pathUrl.split("/");
        self.pageKey='_cr_dr_note_view_'+segments[3];
    },
    metaInfo() {
        var titleStr = "FleetPro Application"
        if (this.showCreditNoteFields) {
            titleStr = "Credit Note View | " +process.env.COPYRIGHT_NAME;
        }else{
            titleStr = "Debit Note View | " +process.env.COPYRIGHT_NAME;
        }
        if (this.note_number != "") {
            titleStr = this.note_number + " | " + titleStr;
        }
        return {
            title:titleStr
        }
    },
    methods : {

        editCreditNote() {
            var self = this;
            self.$router.push("/credit-note/edit/" + self.creditNoteId);
        },
        loadCreditNoteData() {
            var self = this;
            self.loading = true;
            $.ajax({
                url: process.env.ROOT_API + "/credit-note/" + self.creditNoteId,
                type: "GET",
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;

                    if (data.status == "success") {

                        if (data.content.length > 0) {

                            self.note_number = data.content[0].note_number;
                            self.reference = data.content[0].reference;
                            self.note_type = data.content[0].note_type;

                            var storeObject={visited_page: {
                                    path : "Accounting-creditnote |" +data.content[0].note_number,
                                    data : window.location.pathname,
                                    }};
                             self.getRecentlyPagesMethod(storeObject);

                            if (self.note_type == "Credit Note") {
                                self.showCreditNoteFields = true;
                            }else{
                                self.showCreditNoteFields = false;
                            }

                            if (data.content[0].customer_id != null) {
                                self.customer = self.titleCase(data.content[0].cus_code) + " | " + self.titleCase(data.content[0].cus_name);
                            }else{
                                self.customer = '-';
                            }

                            if (data.content[0].invoice_id != null) {
                                self.invoice = data.content[0].invoice_number;
                            }else{
                                self.invoice = "-";
                            }

                            if (data.content[0].vendor_id != null) {
                                self.vendor = self.titleCase(data.content[0].vendor_code) + " | " + self.titleCase(data.content[0].vendor_name);
                            }else{
                                self.vendor = "-";
                            }

                            if (data.content[0].bill_id != null) {
                                self.bill = data.content[0].bill_number;
                            }else{
                                self.bill = "-";
                            }

                            if (data.content[0].location_id != null) {
                                self.location = self.titleCase(data.content[0].loc_code) + " | " + self.titleCase(data.content[0].loc_name);
                            }else{
                                self.location = "-";
                            }

                            if (data.content[0].sales_user_id != null) {
                                self.user = self.formatString(data.content[0].user_first_name + " " + data.content[0].user_last_name);
                            }else{
                                self.user = "-";
                            }

                            self.date_of_issue = data.content[0].date_of_issue;

                            if (data.content[0].expiry_date != null) {
                                self.expiry_date = data.content[0].expiry_date;
                            }else{
                                self.expiry_date = "-";
                            }

                            self.reason = data.content[0].reason;

                            if (data.content[0].notes != null && data.content[0].notes != "") {
                                self.notes = data.content[0].notes;
                            }else{
                                self.notes = "-";
                            }

                            if (data.content[0].term_conditions != null && data.content[0].term_conditions != "") {
                                self.terms_conditions = data.content[0].term_conditions;
                            }else{
                                self.terms_conditions = "-";
                            }

                            self.sub_total = data.content[0].sub_total;
                            self.tax_amount = data.content[0].tax_amount;
                            self.total = data.content[0].total;

                            if (data.content[0].items.length > 0) {

                                self.itemsArr = data.content[0].items;
                            }

                        }

                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,false,'credit-debit-note-view');
                }
            });
        },
        titleCase(str) {
            if (str == null) {
                return;
            } else {
                var value = str.toString()
                return value.charAt(0).toUpperCase() + value.slice(1)
            }
        },
        formatString(data) {
            var self = this;
            var value = data.replace(/_/g, " ");
            var upp = value.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                return letter.toUpperCase();
            });
            return upp;
        },
        amountFormatNumber(amount) {
            const formatter = new Intl.NumberFormat('en-US', {
                minimumFractionDigits:2,
                maximumFractionDigits:2
            });

            return formatter.format(amount);
        },
        amountFormat(amount) {

            return amount.toLocaleString('en-US', {
                style: 'currency',
                currency: 'USD'
            });
        },
        activityLogs(){

          var self = this;
          var path = window.location.pathname;
          var segments = path.split("/");

          self.$root.$emit('activity_log_opted','credit_notes',segments[3]);
          self.activityLogsTabValue = "loadList";     // flag value set to loadList so that filters in list work properly.
          self.active = 2;
        },
    }
}
</script>



// WEBPACK FOOTER //
// src/components/accounting/CreditNoteView.vue